import { CloseButton, Table } from '@mantine/core';
import { IconArrowRight } from '@tabler/icons-react';
import { useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { KeyedRow } from '../../../components/KeyedRow';
import { defaultIconStyle } from '../../../theme/styling/iconStyling';
import {
	formatToCurrency,
	formatToDateStringOrDefault,
	formatToTimeStringOrDefault,
} from '../../../util/formatting';
import { undefinedCheck } from '../../../util/undefinedCheck';
import type { CashDeclarationDto } from '../types/CashDeclarationDto';

interface CashDeclarationRowProps {
	originalCashDeclaration: CashDeclarationDto;
}

export function CashDeclarationRow({
	originalCashDeclaration,
}: CashDeclarationRowProps) {
	const { organisation } = useParams();

	const [cashDeclaration, setCashDeclaration] = useState(
		originalCashDeclaration,
	);

	const navigate = useNavigate();

	return (
		<>
			<KeyedRow>
				<Table.Td>{undefinedCheck(cashDeclaration.branchName)}</Table.Td>
				<Table.Td>
					{formatToDateStringOrDefault(cashDeclaration.dateTime)}
				</Table.Td>
				<Table.Td>
					{formatToTimeStringOrDefault(cashDeclaration.dateTime)}
				</Table.Td>
				<Table.Td>{formatToCurrency(cashDeclaration.cashInDrawer)}</Table.Td>
				<Table.Td>{formatToCurrency(cashDeclaration.bankingValue)}</Table.Td>
				<Table.Td>{formatToCurrency(cashDeclaration.floatValue)}</Table.Td>
				<Table.Td>
					{undefinedCheck(cashDeclaration.twentyNotes.toString())}
				</Table.Td>
				<Table.Td>
					{undefinedCheck(cashDeclaration.tenNotes.toString())}
				</Table.Td>
				<Table.Td>
					{undefinedCheck(cashDeclaration.fiveNotes.toString())}
				</Table.Td>
				<Table.Td>{undefinedCheck(cashDeclaration.coins.toString())}</Table.Td>
				<Table.Td>{undefinedCheck(cashDeclaration.bankType)}</Table.Td>
				<Table.Td>
					<Table.Td>
						<CloseButton
							icon={<IconArrowRight {...defaultIconStyle} />}
							onClick={() =>
								navigate(
									`/${organisation}/epos/eod-logs?pharmacy=${encodeURIComponent(cashDeclaration.branchName)}`,
								)
							}
						/>
					</Table.Td>
				</Table.Td>
			</KeyedRow>
		</>
	);
}
